import React from 'react';
import classNames from 'classnames';
import '../dashboard.css';

interface KpiStatProps {
  value: React.ReactNode;
  label: string;
  tone?: 'default' | 'success' | 'warning' | 'error' | 'primary';
}

// Overdue/attention numbers read amber, as in the dashboard design — red is
// kept for actual failures elsewhere in the app.
const TONE_CLASS: Record<string, string | undefined> = {
  default: undefined,
  success: 'is-green',
  warning: 'is-amber',
  error: 'is-amber',
  primary: 'is-brand',
};

/** One cell of a section's stat strip — label over a 22px number. */
const KpiStat: React.FC<KpiStatProps> = ({ value, label, tone = 'default' }) => (
  <div className="dash-stat">
    <span className="dash-stat-label">{label}</span>
    <span className={classNames('dash-stat-value', TONE_CLASS[tone])}>{value}</span>
  </div>
);

export default KpiStat;
